import merge from 'lodash-es/merge';
import get from 'lodash-es/get';

import { logger } from '@digital-dealer/utils';

import basicConfig from './basicConfig';
import TConfigOverride from './types/TConfigOverride';

class ConfigurationService {
  private config: Record<string, any> = basicConfig;

  public get = <ReturnType = boolean>(key: string): ReturnType => {
    const value = get(this.config, key);

    if (typeof value === 'undefined') {
      logger.trackWarning(`ConfigurationService. Value for ${key} is missing`, {
        catcher: 'ConfigurationService.get',
      });

      return key as unknown as ReturnType;
    }

    return value;
  };

  public override = (newConfig: TConfigOverride): void => {
    this.config = merge(this.config, newConfig);
  };
}

export default new ConfigurationService();
